import api from '../../config/axios.js';
import moment from 'moment';
import 'moment/dist/locale/pt-br';
moment.locale('pt-br');

let billingRequestId = 0;

const state = {
    metricsMonthBillingGraphic:{
        invoicing: "0",
        goal: "0"
    },
    goalsList: [],
    currentGoals: {},
    currentDeleteGoals: {},
}
const getters = {
    getMetricsMonthBillingGraphic: state => state.metricsMonthBillingGraphic,
    getGoalsList: state => state.goalsList,
    getCurrentGoals: state => state.currentGoals,
    getCurrentDeleteGoals: state => state.currentDeleteGoals,
}
const actions = {
    // BUSCANDO MÉTRICAS DO FATURAMENTO MÊS ATUAL
        async fetchGoalsList({ commit }){
            await api.axios.get('/api/goals').catch((error) => {
                console.log("tratar erro de metricas do mes atual", error);
            }).then(response => {
                if(response && response.data){
                    commit("fetchGoalsList", response.data.data);
                }
            });
        },
    // SETANDO GOALS PARA FAZER UPDATE
        async setCurrentGoals({ commit }, goal){
            commit("setCurrentGoals", goal);
        },
    // SETANDO GOALS PARA FAZER DELETE
        async setCurrentDeleteGoals({ commit }, goal){
            commit("setCurrentDeleteGoals", goal);
        },
    
    






    // BUSCANDO MÉTRICAS DO FATURAMENTO MÊS ATUAL
        async fetchMetricsMonthBillingGraphic({ commit }, params) {
            const requestId = ++billingRequestId;
            try {
                const { data } = await api.axios.get(`/api/metrics/billing/month/${params?.month ?? null}/${params?.year ?? null}`);
                if (requestId === billingRequestId) commit('setMetricsMonthBillingGraphic', data);
            } catch (error) {
                if (requestId === billingRequestId) commit('setMetricsMonthBillingGraphic', { invoicing: '0', goal: '0' });
            }
        },
    // DECLARANDO FATURAMENTO
        async declareBilling({ commit }, data){
            await api.axios.post('/api/declare/billing', data).catch((error) => {
                console.log("tratar erro de declaração do faturamento", error);
            }).then(response => {
                if(response && response.data){
                    console.log(response.data);
                }
            });
        },
}

const mutations = {
        resetVisibleBilling(state) {
            ++billingRequestId;
            state.metricsMonthBillingGraphic = { invoicing: '0', goal: '0' };
        },
    // BUSCANDO MÉTRICAS DO FATURAMENTO MÊS ATUAL
        setMetricsMonthBillingGraphic: function(state, data){
            state.metricsMonthBillingGraphic = data;
        },
    // LISTANDO AS METAS DA EMPRESA
        fetchGoalsList: function(state, data){
            state.goalsList = data;
        },
    // SETANDO GOAL ATUAL PARA FAZER UPDATE
        setCurrentGoals: function(state, data){
            state.currentGoals = data;
        },
    // SETANDO GOAL ATUAL PARA FAZER DELETE
        setCurrentDeleteGoals: function(state, data){
            state.currentDeleteGoals = data;
        },
}
export default {
    state,
    getters,
    actions,
    mutations
}